import { LazyLoadImage } from "react-lazy-load-image-component";

import "./LazyLoadBackgroundImage.scss";

const LazyLoadBackgroundImage = ({ src, alt, children, className, height }) => {
  return (
    <div
      className={`lazy-load-bg-image__wrapper ${className || ""}`}
      style={{ height: height || "" }}
    >
      <LazyLoadImage src={src} alt={alt || ""} className={"background-image"} />
      {children}
    </div>
  );
};

export default LazyLoadBackgroundImage;
